import * as React from "react";
import { Tabs as TabsPrimitive } from "radix-ui";
import { cn } from "@/lib/utils";

const Tabs = TabsPrimitive.Root;

function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn("flex items-end gap-0 border-b border-line", className)}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  attention,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger> & { attention?: boolean }) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      data-attention={attention || undefined}
      className={cn(
        "inline-flex items-center gap-2 px-3.5 py-2 text-[12.5px] font-medium text-ink-700 -mb-px border-b-2 border-transparent",
        "hover:text-ink-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-p-600 focus-visible:ring-offset-1",
        "data-[state=active]:font-semibold data-[state=active]:text-ink-900 data-[state=active]:border-p-600",
        "data-[attention=true]:text-vroom-red data-[attention=true]:data-[state=active]:border-vroom-red",
        className,
      )}
      {...props}
    />
  );
}

export { Tabs, TabsList, TabsTrigger };
